// organize-imports-ignore
import "./polyfills";
import "@styles/index.css";
import { loadSdkThemeCssForBootstrap } from "@utils/loadSdkThemeCss";
import React from "react";
import ReactDOM from "react-dom/client";
import { EnhancedApp } from "./App.tsx";
import { runOnIdle } from "@utils/runOnIdle";

const renderApp = () => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <EnhancedApp />
    </React.StrictMode>,
  );

  runOnIdle(() => {
    import("./deferred-init").then((m) => m.initDeferred());
  }, 5000);
};

void loadSdkThemeCssForBootstrap().then(renderApp, renderApp);
